import { bus } from '@core/events/eventSystem';
import constants from './constants';
import axios from 'axios';

const api = axios.create({
  baseURL: constants.ENDPOINTS.PRODUCTS.BASE,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
});

// Fetch countries for mobile operations
bus.on(constants.EVENTS.PRODUCTS.FETCH_COUNTRIES, async () => {
  try {
    const response = await api.get(constants.ENDPOINTS.PRODUCTS.COUNTRIES + constants.ENDPOINTS.PARAMS);
    bus.emit(constants.EVENTS.PRODUCTS.FETCH_COUNTRIES_SUCCESS, response.data.data.data);
  } catch (error) {
    console.error('API error fetching countries:', error);
    bus.emit(constants.EVENTS.PRODUCTS.FETCH_COUNTRIES_ERROR, error);
  }
});

// Fetch operators by country and type (airtime/data/bundle)
bus.on(constants.EVENTS.PRODUCTS.FETCH_OPERATORS, async ({ countryCode = 'BJ', type = constants.ENDPOINTS.TYPES.AIRTIME }) => {
  const url = constants.ENDPOINTS.PRODUCTS.OPERATORS.replace('{countryCode}', countryCode) + constants.ENDPOINTS.PARAMS + '&type=' + type;
  try {
    const response = await api.get(url);
    // Extract operators array from nested response structure
    const operators = response.data.data.data || response.data.data || response.data || [];
    bus.emit(constants.EVENTS.PRODUCTS.FETCH_OPERATORS_SUCCESS, operators);
  } catch (error) {
    console.error('API error fetching operators:', error);
    bus.emit(constants.EVENTS.PRODUCTS.FETCH_OPERATORS_ERROR, error);
  }
});

// Buy airtime/data/bundle
bus.on(constants.EVENTS.PRODUCTS.BUY_MOBILE, async (orderData) => {
  // Expected orderData format:
  // {
  //   service: 'ecoxurf',
  //   requestId: string,
  //   operationName: 'airtime' | 'databundle' | 'carrierbundle',
  //   amount: number,
  //   id: string (operatorId),
  //   recipientPhone: string,
  //   senderPhone: string,
  //   operatorId: number,
  //   countryCode: string
  // }

  try {
    const response = await api.post(constants.ENDPOINTS.PRODUCTS.BUY + constants.ENDPOINTS.PARAMS, {
      service: 'ecoxurf',
      ...orderData
    });
    bus.emit(constants.EVENTS.PRODUCTS.BUY_MOBILE_SUCCESS, response.data);
  } catch (error) {
    bus.emit(constants.EVENTS.PRODUCTS.BUY_MOBILE_ERROR, error);
  }
});
